import React, { Suspense, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchResultsSideBar from "../../components/enhancedSearch/SearchResults/SearchResultsSideBar";
import WrappedFooter from "../../components/WrappedFooter.jsx";
import EnhancedSearchResults from "../../components/enhancedSearch/SearchResults/EnhancedSearchResults";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader/Loader.jsx";
import SearchPagination from "../../components/enhancedSearch/SearchResults/SearchPagination.jsx";
import styles from "./EnhancedSearchResultsPage.module.scss";

const NavBar = React.lazy(() => import("../../components/navBar.jsx"));
const TopicBanner = React.lazy(
  () => import("../../components/topicBanner.jsx"),
);
const TopicToolsSticky = React.lazy(
  () => import("../../components/topicToolsSticky.jsx"),
);

const EnhancedSearchResultsPage = () => {
  const navigate = useNavigate();
  const [withinSearchVal, setWithinSearchVal] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const location = useLocation();
  const pathname = location.pathname;
  const search = location.search;
  const [showFilterBar, setShowFilterBar] = useState(false);

  return (
    <div id="tgsearch">
      <Suspense fallback={<Loader />}>
        <NavBar push={navigate} setWithinSearchVal={setWithinSearchVal} />
        <TopicBanner pathname={pathname} search={search} push={navigate} />
        <div className="container">
          <div className={styles.mainContent}>
            <SearchResultsSideBar search={search} navigate={navigate} />
            <EnhancedSearchResults
              search={search}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              showFilterBar={showFilterBar}
              setShowFilterBar={setShowFilterBar}
            />
          </div>
        </div>
        <SearchPagination selectedTab={selectedTab} />
        <TopicToolsSticky pathname={pathname} />
        <WrappedFooter />
      </Suspense>
    </div>
  );
};

export default EnhancedSearchResultsPage;
